import { Spade } from 'lucide-react';

/** Sidebar brand: gradient mark + product name. */
export function BrandMark(): JSX.Element {
  return (
    <span className="flex items-center gap-2.5">
      <span
        aria-hidden
        className="brand-mark flex h-7 w-7 items-center justify-center rounded-lg shadow-[0_6px_16px_-6px_var(--brand)]"
      >
        <Spade className="h-4 w-4 text-white" strokeWidth={2.25} />
      </span>
      <span className="flex flex-col leading-tight">
        <span className="text-[0.875rem] font-bold text-sidebar-foreground">Spade</span>
        <span className="text-[0.6875rem] font-medium text-sidebar-muted-foreground">Outreach</span>
      </span>
    </span>
  );
}
